// PageEstimate Component

import React from 'react'
import _ from 'lodash'

import app from '../../../app.jsx'
import eventfilters from '../../../lib/eventfilters.jsx'
import InvoiceUtil from '../../../lib/invoiceutil.js'
import PageBase from '../../../common/page/page_base/page_base.jsx'
import Button from '../../../common/common/button/button.jsx'
import List from '../../../../components/List/List.jsx'
import Grid from '../../../common/common/grid/grid.jsx'
import ContentMessage from '../../../common/common/content_message/content_message.jsx'
import EstimateItem from '../../estimate/estimate_item/estimate_item.jsx'
import DialogSetting from '../../../contact/dialog/dialog_setting/dialog_setting.jsx'
import ConfirmDelete from '../../../common/common/confirm_delete/confirm_delete.jsx'
import DialogEstimateAdd from '../../../estimate/dialog/dialog_estimate_add/dialog_estimate_add.jsx'
import DialogMail from '../../../common/dialog/dialog_email/dialog_email.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import DialogApproveEstimate from '../../dialog/dialog_estimate_approve/dialog_estimate_approve.jsx'
import PopupCompanyProfileData from '../../../common/popup/popup_companyprofile_data/popup_companyprofile_data.jsx'
import ReportPriceCell from '../../../report/report/report_pricecell/report_pricecell.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import Util from '../../../lib/util.jsx'
import EmailUtil from '../../../lib/emailutil.js'
import DateUtil from '../../../lib/dateutil.jsx'
import DialogEstimateCopy from '../../dialog/dialog_estimate_copy/dialog_estimate_copy.jsx'
import ProfilerUtil from '../../../lib/profilerutil.jsx'
import PageHeader from '../../../theme/layout/page_header/page_header.jsx'
import { EstimatesIcon } from '../../../common/layout/menu_icons/estimates.jsx'

class PageEstimate extends PageBase {
  constructor (props) {
    super(props, 'estimate', 'estimate', 'estimate')

    this.state = {
      isLoading: true,
      dataDate: null,
      estimate: null,
      showDataAlert: true,
      profilerId: null,
      bShowDialog: false
    }

    this.data = {
      estimates: [],
      stat: null,
      total: 0,
      countLoaded: 0,
      canPaginate: true,
      sort: 'createdById',
      sortAsc: true,
      pageNo: 1,
      pageState: {
        type: 'grid',
        sort: 'createdById',
        sortAsc: true,
        filter: null
      },
      companyFields: []
    }

    this._setFABButtonState(true, false)
    this._initRealTimeVariables()
    this._references = {
      dialogEstimateAdd: React.createRef(),
      refDialogEstimateCopy: React.createRef(),
      refDialogApproveEstimate: React.createRef(),
      refdialogMail: React.createRef(),
      refHeaderEstimate: React.createRef(),
      confirmDelete: React.createRef(),
      confirmDecline: React.createRef(),
      estimateSettingDialog: React.createRef(),
      popupcompanyprofiledata: React.createRef()
    }

    /* Initialize profiler */
    this._profiler = new ProfilerUtil(this._pageIdent, 3) // Average time 3 seconds
    this._profiler.start()

    this._bUnMounted = false
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._handleDocumentKeyDown)
    this._getData(false)
    this._initEvents()

    // Calculate and save profiler, Hardcode profiler id as 1, since it is the first call of profiler
    this._profiler.stop(1)
  }

  componentWillUnmount () {
    this._bUnMounted = true

    this._releaseEvents()
    document.body.removeEventListener('keydown', this._handleDocumentKeyDown)

    this._profiler = null
  }

  componentDidUpdate (prevProps, prevState) {
    if (
      this._profiler &&
      (!prevState || prevState.profilerId !== this.state.profilerId) &&
      this.state.profilerId
    ) {
      this._profiler.stop(this.state.profilerId)
    }
  }

  renderContent () {
    const estimate = this.state.estimate
    const pdfFileName = estimate
      ? Util.getPdfFileName(
        'estimate',
        estimate.estimateNumber,
        estimate.status
      )
      : ''
    const suggestions =
      estimate && estimate.contact
        ? EmailUtil.getEmailSuggestions(estimate.contact)
        : []

    return (
      <div className='pageinnercont'>
        {this._renderMessage()}
        {this._renderGridOrList()}
        {this._renderSettingsDialog()}
        <DialogEstimateAdd
          ref={this._references.dialogEstimateAdd}
          getProjects={this._getProjects.bind(this)}
          contactSearch={this._onSearchContact.bind(this)}
          onSubmit={this._onSubmitAddEstimate.bind(this)}
        />
        <DialogApproveEstimate
          ref={this._references.refDialogApproveEstimate}
          onSubmit={this._onSubmitEstimateApprove.bind(this)}
        />
        <DialogEstimateCopy
          ref={this._references.refDialogEstimateCopy}
          contactSearch={this._onSearchContact.bind(this)}
          getProjects={this._getProjects.bind(this)}
          onSubmit={this._onSubmitEstimateCopy.bind(this)}
        />
        <DialogMail
          ref={this._references.refdialogMail}
          mailSuggestions={suggestions}
          isLoading={this.state.isLoading}
          downloadUrl={`/estimate/preview/${app.getTeamId()}/${
            app.loggedInId
          }/${estimate ? estimate.id : ''}/${pdfFileName}`}
          showMultiAttachments
          showLanguage={app.teamCountry === 'NL' || app.teamCountry === 'DE'}
          onSubmit={this._onSubmitMail.bind(this)}
        />
        <PopupCompanyProfileData
          ref={this._references.popupcompanyprofiledata}
          companyData={this.data.companyFields}
          onClick={this._onClickAlert.bind(this)}
        />
      </div>
    )
  }

  _handleDocumentKeyDown = evt => {
    if (
      this._references.dialogEstimateAdd.current &&
      (this.ignoreAutoSearch ||
        this._references.dialogEstimateAdd.current.isActive() ||
        this._references.refDialogEstimateCopy.current.isActive() ||
        this._references.refDialogApproveEstimate.current.isActive())
    ) {
      return
    }

    if (this._references.refHeaderEstimate.current && !this.state.bShowDialog) {
      const keyCode = evt.keyCode || 0

      let bSearch = true
      if (
        keyCode === 13 ||
        keyCode === 9 ||
        keyCode === 27 ||
        keyCode === 17 ||
        keyCode === 224
      ) {
        bSearch = false
      } else if (evt.ctrlKey || evt.altKey || evt.shiftKey || evt.metaKey) {
        bSearch = false
      }

      if (keyCode === 27) {
        this._references.refHeaderEstimate.current.onEscKeyDown()
      } else if (
        bSearch &&
        this._references.refHeaderEstimate.current.canShowSearch()
      ) {
        this._references.refHeaderEstimate.current.showSearch()
      }
    }
  }

  getContentClassname () {
    return this.data.pageState.type === 'grid' ? 'alt' : null
  }

  /* Event handlers */
  _onClickAlert (_ev) {
    app.changePage('setting-companyprofile')
  }

  _onGridItemClick (estimate, column) {
    if (
      column &&
      (column.identifier === 'title' || column.identifier === 'projectNumber')
    ) {
      app.changePage('projectview-budget', estimate.projectId)
    } else if (estimate && estimate.id) {
      app.changePage('estimate-view', estimate.id)
    }
  }

  _onGridItemSettingClick (estimate) {
    if (estimate) {
      let estimateNo = estimate.estimateNumber
      if (estimate && estimate.reviewedOn) {
        estimateNo += ` / ${DateUtil.getDisplayDate(estimate.reviewedOn)}`
      }

      this.setState({ estimate: estimate })
      if (this._references.estimateSettingDialog.current) {
        this._references.estimateSettingDialog.current.show(
          estimate.project ? estimate.project.title : '',
          estimateNo,
          estimate.contact && estimate.contact.imageUrl
            ? estimate.contact.imageUrl
            : '',
          IntlUtil.convertMessage(Util.getTranslatedStatus(estimate.status))
        )
      }
    }
  }

  onAdd () {
    if (this._references.dialogEstimateAdd.current) {
      this._references.dialogEstimateAdd.current.show()
    }
  }

  _onEdit (estimate, e) {
    e.preventDefault()
    if (estimate && estimate.id) {
      app.changePage('estimate-view', estimate.id)
    }
  }

  _onSubmitMail (mailObj) {
    app.debug('PageEstimateView: _onSubmitMail [Start]')
    this.setState({ isLoading: true })

    EmailUtil.sendEstimateMail(mailObj, this.state.estimate)
      .then(_result => {
        if (this._references.refdialogMail.current) {
          this._references.refdialogMail.current.hide()

          if (this._references.estimateSettingDialog.current) {
            this._references.estimateSettingDialog.current.hide()
          }
        }

        this.setState({ isLoading: false, bShowDialog: false })
      })
      .catch(err => {
        app.debug('PageEstimate: _onSubmitMail err', err)
      })
  }

  _onSendMail (estimate, event) {
    if (event) {
      event.preventDefault()
    }

    app.debug('### PageEstimate - _onSendMail')
    const params = { query: {} }
    app
      .service('/api/estimate/mail')
      .get(estimate.id, params)
      .then(result => {
        this.setState({ bShowDialog: true })
        if (result && this._references.refdialogMail.current) {
          this._references.refdialogMail.current.show(result)
        }
      })
      .catch(err => {
        app.debug('PageEstimate: _onSendMail err', err)
      })
  }

  _onDelete (e) {
    e.preventDefault()
    this.data.pageNo = 1
    if (this._references.confirmDelete.current) {
      this._references.confirmDelete.current.show()
    }
  }

  _onApprove (event) {
    event.preventDefault()
    const estimate = this.state.estimate

    if (estimate) {
      const estimateObj = {
        estimateNumber: estimate.estimateNumber,
        reviewedOn: estimate.reviewedOn,
        addressOptions: this._getContactAddressOptions(estimate),
        addresses:
          estimate && estimate.contact && estimate.contact.addresses
            ? estimate.contact.addresses
            : null,
        contactPersonOptions: this._getContactPersonOptions(estimate.contact),
        contactPerson: estimate.contactPerson
          ? estimate.contactPerson.name
          : '',
        contactAddress: estimate.contactAddress ? estimate.contactAddress : '',
        total: estimate.budget.total
      }
      if (this._references.estimateSettingDialog.current) {
        this._references.estimateSettingDialog.current.hide()
      }
      if (this._references.refDialogApproveEstimate.current) {
        this._references.refDialogApproveEstimate.current.show(estimateObj)
      }
    }
  }

  _getContactAddressOptions (estimate) {
    const addressOptions = []
    const contact = estimate.contact
    if (contact && contact.addresses && contact.addresses.length > 0) {
      contact.addresses.map(address => {
        const existTypeOption = _.find(
          addressOptions,
          addressOption => addressOption.label === address.type
        )
        const label = IntlUtil.convertMessage(
          `contact.view.type${address.type}`
        )
        if (existTypeOption === undefined) {
          addressOptions.push({
            label: label,
            value: address.type.toLowerCase()
          })
        }
      })
    }

    if (estimate.contactAddress && addressOptions[0].value === undefined) {
      const label = IntlUtil.convertMessage(
        `contact.view.type${estimate.contactAddress.type}`
      )
      addressOptions.push({
        label: label,
        value: estimate.contactAddress.type.toLowerCase()
      })
    }

    return addressOptions
  }

  _getContactPersonOptions (contact) {
    const contactPersonOptions = []
    if (
      contact &&
      contact.contactPersons &&
      contact.contactPersons.length > 0
    ) {
      contact.contactPersons.map(contactPerson => {
        const label =
          contactPerson.name +
          (contactPerson.email ? ' - ' + contactPerson.email : '')
        contactPersonOptions.push({
          label: label,
          value: contactPerson.name,
          obj: contactPerson
        })
      })
    }

    return contactPersonOptions
  }

  _onDecline (event) {
    event.preventDefault()
    if (this._references.confirmDecline.current) {
      this._references.confirmDecline.current.show()
    }
  }

  _onClickDeclineConfirm (event) {
    event.preventDefault()

    app.debug('### PageEstimate - _onDecline')
    if (this.state.estimate) {
      app
        .service('/api/estimate')
        .patch(this.state.estimate.id, { status: 'Declined' })
        .then(_decRes => {
          if (this._references.estimateSettingDialog.current) {
            this._references.estimateSettingDialog.current.hide()
          }
        })
        .catch(decErr => {
          app.debug('PageEstimate _onDecline err', decErr)
        })
    }
  }

  _onSubmitEstimateApprove (estObj, onFinish = () => {}) {
    const estimate = this.state.estimate
    app
      .service('/api/estimate')
      .patch(estimate.id, estObj)
      .then(_estRes => {
        if (this._references.refDialogApproveEstimate.current) {
          this._references.refDialogApproveEstimate.current.hide()
        }
      })
      .catch(estErr => {
        app.debug('PageEstimate: _onSubmitEstimateApprove err', estErr)
      })
      .finally(() => {
        if (onFinish) onFinish()
      })
  }

  _onInvoice (e) {
    e.preventDefault()
    const estimateInvoiceObj = {
      type: 'based-on-estimate',
      estimateId: this.state.estimate.id,
      projectId: this.state.estimate.projectId,
      contactId: this.state.estimate.contactId,
      referenceNo: this.state.estimate.referenceNumber,
      percentage: 100
    }
    return InvoiceUtil.createInvoice(estimateInvoiceObj, null, (err, res) => {
      if (err) {
        app.debug('PageEstimate _onInvoice err', err)
      } else {
        if (this._references.estimateSettingDialog.current) {
          this._references.estimateSettingDialog.current.hide()
        }
        app.changePage('invoice-view', res.id)
      }
    })
  }

  _onCopy (estimate) {
    if (this._references.estimateSettingDialog.current) {
      this._references.estimateSettingDialog.current.hide()
    }
    if (this._references.refDialogEstimateCopy.current) {
      this._references.refDialogEstimateCopy.current.show(estimate)
    }
  }

  _onClickDeleteConfirm (e) {
    if (!this.state.estimate.id) {
      return false
    }

    e.preventDefault()
    app
      .service('/api/estimate')
      .remove(this.state.estimate.id)
      .then(_deleteRes => {
        if (this._references.estimateSettingDialog.current) {
          this._references.estimateSettingDialog.current.hide()
        }
      })
      .catch(deleteErr => {
        app.debug('PageEstimate delete err', deleteErr)
      })
  }

  _onCloseSetting () {
    if (
      this._references.confirmDelete &&
      this._references.confirmDelete.current
    ) {
      this._references.confirmDelete.current.hide()
    }

    if (
      this._references.confirmDecline &&
      this._references.confirmDecline.current
    ) {
      this._references.confirmDecline.current.hide()
    }

    this.setState({ bShowDialog: false })
  }

  /* Private Functions */
  _getData (bReload) {
    // Start profiler
    const profilerId = this._profiler ? this._profiler.start() : 0

    this._setDataLoading()

    const skip = (this.data.pageNo - 1) * 20

    const params = {
      query: {
        bUpdatePageState: bReload,
        pageState: this.data.pageState,
        pageIdent: this._pageIdent,
        estimate: {
          $limit: 20,
          $skip: skip,
          $sort: {},
          $client: {
            subObjects: {
              contact: [
                'company',
                'image',
                'imageUrl',
                'addresses',
                'contactPersons'
              ],
              project: ['title', 'status', 'projectNumber'],
              items: []
            }
          }
        }
      }
    }

    app.service('/api/page/estimate').timeout = 10000

    app
      .service('/api/page/estimate')
      .find(params)
      .then(result => {
        this._onPageDataRecieved(result.pageData)

        this.data.stat = result.stat
        this.data.companyFields = result.companyFields

        if (result.estimateResult) {
          const estimate = result.estimateResult

          this.data.estimates =
            this.data.pageNo > 1
              ? this.data.estimates.concat(estimate.data)
              : estimate.data
          this.data.total = estimate.total
          this.data.countLoaded =
            params.query.estimate.$limit * this.data.pageNo
          this.data.canPaginate = !(this.data.countLoaded > this.data.total)
        }

        this._onDataReceived(null, profilerId)
      })
      .catch(err => {
        app.debug('PageEstimate: _getData ERROR', err)
        this._onDataReceived(err, profilerId)
      })
  }

  _getProjects (contactId, callback) {
    if (contactId) {
      const params = {
        query: {
          contactId: contactId,
          status: { $nin: ['closed'] }
        }
      }

      app
        .service('/api/project')
        .find(params)
        .then(result => {
          if (result) {
            const options = result.data.map(obj => ({
              label: obj.title,
              value: obj.id
            }))
            /* eslint standard/no-callback-literal: "off" */
            callback(options)
          } else {
            /* eslint standard/no-callback-literal: "off" */
            callback([])
          }
        })
        .catch(err => {
          app.debug('PageEstimate: _getProjects err', err)
          /* eslint standard/no-callback-literal: "off" */
          callback([])
        })
    } else {
      /* eslint standard/no-callback-literal: "off" */
      callback([])
    }
  }

  _onSubmitAddEstimate (estimateObj, onFinish = () => {}) {
    app
      .service('/api/estimate')
      .create(estimateObj)
      .then(result => {
        if (this._references.dialogEstimateAdd.current) {
          this._references.dialogEstimateAdd.current.hide()
        }
        if (result && result.id) {
          app.changePage('estimate-view', result.id)
        }
      })
      .catch(err => {
        app.debug('PageEstimate: _onSubmitAddEstimate err', err)
      })
      .finally(() => {
        if (onFinish) onFinish()
      })
  }

  _onSubmitEstimateCopy (estimateObj) {
    app
      .service('/api/estimate/copy')
      .create(estimateObj)
      .then(result => {
        if (result && result.id) {
          app.changePage('estimate-view', result.id)
        }
      })
      .catch(err => {
        app.debug('PageEstimate: _onSubmitCopyEstimate err', err)
      })
  }

  _onDataReceived (err, profilerId) {
    if (this._bUnMounted) return

    this._setDataLoaded()

    if (err) {
      app.debug('PageEstimate: _onDataReceived Error', err)
      this._setFABButtonVisible(false)
    } else {
      if (
        this.data.companyFields.length > 0 &&
        this.state.showDataAlert &&
        this._references.popupcompanyprofiledata &&
        this._references.popupcompanyprofiledata.current
      ) {
        this._references.popupcompanyprofiledata.current.show()
      }

      app.debug('PageEstimate: _onDataReceived [done]')

      if (this.data.estimates && this.data.estimates.length > 0) {
        this._setFABButtonVisible(true)
      } else {
        this._setFABButtonVisible(false)
      }
      this.setState({ showDataAlert: false })
    }

    this.setState({
      isLoading: false,
      dataDate: new Date(),
      profilerId: profilerId
    })
  }

  _onUserStateRecieved (userState) {
    const pageState = this._getPageUserState(userState)
    if (pageState) {
      this.data.pageState = {
        sort: pageState.sort || 'createdById',
        sortAsc: pageState.sortAsc !== undefined ? pageState.sortAsc : true,
        type: pageState.type || 'grid',
        filter: pageState.filter || null
      }
    }
  }

  _renderMessage () {
    if (!this.state.isLoading && !this.data?.estimates?.length) {
      return (
        <ContentMessage
          message='estimate.view.noEstimateTitle'
          info='estimate.view.noEstimateInfo'
          showAddPrefix
          showAdd
          onAdd={this.onAdd.bind(this)}
        />
      )
    }

    return null
  }

  _renderGridOrList () {
    if (this.state.isLoading || !this.data.estimates.length) {
      return null
    }

    let bShowLoader = false
    if (this.data.estimates && this.data.estimates.length < this.data.total) {
      bShowLoader = true
    }

    const estimates = this.data.estimates.map(estimate => ({
      ...estimate,
      status: IntlUtil.convertMessage(estimate.status.toLowerCase())
    }))

    if (this.data.pageState.type === 'list') {
      return (
        <div className='listwrap'>
          <List
            objectList={estimates}
            sortOptions={this._getSortOptions()}
            columns={this._getListCloumns()}
            onPaginate={this._onPaginate.bind(this)}
            onSort={this._onSort.bind(this)}
            renderCustomCell={this._onRenderList.bind(this)}
            onView={this._onGridItemClick.bind(this)}
            actionIcon='common-action-setting'
            sort={this.data.pageState.sort}
            sortAsc={this.data.pageState.sortAsc}
            showLoader={bShowLoader}
            onSettings={this._onGridItemSettingClick.bind(this)}
          />
        </div>
      )
    }

    return (
      <div className='gridwrap'>
        <Grid
          objectList={estimates}
          sortOptions={this._getSortOptions()}
          onPaginate={this._onPaginate.bind(this)}
          sort={this.data.pageState.sort}
          sortAsc={this.data.pageState.sortAsc}
          showLoader={bShowLoader}
          onSort={this._onSort.bind(this)}
          onRenderGrid={this._onRenderGrid.bind(this)}
        />
      </div>
    )
  }

  _renderSettingsDialog () {
    if (this.state.isLoading) {
      return null
    }
    const estimate = this.state.estimate

    let bDisable = false
    if (
      estimate &&
      (estimate.status === 'Approved' || estimate.status === 'Declined')
    ) {
      bDisable = true
    }

    let bProjectClosed = false
    if (
      estimate &&
      estimate.project &&
      estimate.project.status &&
      estimate.project.status === 'closed'
    ) {
      bProjectClosed = true
    }

    const _buttonDeleteClass = `button_dialog button_dialogdlt ${
      bDisable || bProjectClosed ? ' disabled' : ''
    }`
    const _buttonApproveClass = `button_dialog button_dialogapprove ${
      bDisable || bProjectClosed ? ' disabled' : ''
    }`
    const _buttonDeclineClass = `button_dialog button_dialogdecline ${
      bDisable || bProjectClosed ? ' disabled' : ''
    }`
    const _buttonInvoiceEstimateClass = `button_dialog button_dialogapprove ${
      bProjectClosed ? ' disabled' : ''
    }`

    const _actionBtnClass = `action-btn ${
      bDisable || bProjectClosed ? ' disable' : ''
    }`
    const _actionBtnCloseClass = `action-btn ${
      bProjectClosed ? ' disable' : ''
    }`

    const tooltipDelete =
      bDisable || bProjectClosed ? 'estimate.view.tipDisableDeleteText' : null
    const tooltipApprove =
      bDisable || bProjectClosed ? 'estimate.view.tipDisableApproveText' : null
    const tooltipDecline =
      bDisable || bProjectClosed ? 'estimate.view.tipDisableDeclineText' : null
    const tooltipInvoiceEstimate = bProjectClosed
      ? 'estimate.view.tipDisableInvoiceEstimateText'
      : null
    const pdfFileName = estimate
      ? Util.getPdfFileName(
        'estimate',
        estimate.estimateNumber,
        estimate.status
      )
      : ''

    return (
      <DialogSetting
        ref={this._references.estimateSettingDialog}
        onClose={this._onCloseSetting.bind(this)}
        className='alt'
      >
        <div className='actionboard-row act-row'>
          <div className='actionboard-col2 alert-col2'>
            <div
              className='action-btn'
              onClick={this._onEdit.bind(this, estimate)}
            >
              <Button
                icon='action-edit'
                className='button_dialog'
                canHover={false}
              />
              <span className='label'>
                <IntlMessage ident='estimate.view.editText' />
              </span>
            </div>
          </div>
          <div className='actionboard-col2 alert-col2'>
            <div
              className={_actionBtnClass}
              onClick={
                !bDisable && !bProjectClosed ? this._onDelete.bind(this) : null
              }
            >
              <Button
                icon='action-delete'
                className={_buttonDeleteClass}
                canHover={false}
                tooltip={tooltipDelete}
                tooltipPosition='top'
              />
              <span className='label'>
                <IntlMessage ident='estimate.view.deleteText' />
              </span>
            </div>
          </div>
        </div>
        <div className='actionboard-row act-row'>
          <div
            className='actionboard-col2 alert-col2'
            id='options-approve-estimate'
          >
            <div
              className={_actionBtnClass}
              onClick={
                !bDisable && !bProjectClosed ? this._onApprove.bind(this) : null
              }
            >
              <Button
                icon='action-approve'
                className={_buttonApproveClass}
                canHover={false}
                tooltip={tooltipApprove}
                tooltipPosition='top'
              />
              <span className='label'>
                <IntlMessage ident='estimate.view.approveText' />
              </span>
            </div>
          </div>
          <div
            className='actionboard-col2 alert-col2'
            id='options-deny-estimate'
          >
            <div
              className={_actionBtnClass}
              onClick={
                !bDisable && !bProjectClosed ? this._onDecline.bind(this) : null
              }
            >
              <Button
                icon='action-decline'
                className={_buttonDeclineClass}
                canHover={false}
                tooltip={tooltipDecline}
                tooltipPosition='top'
              />
              <span className='label'>
                <IntlMessage ident='estimate.view.declineText' />
              </span>
            </div>
          </div>
        </div>
        <div className='actionboard-row act-row'>
          <div className='actionboard-col2 alert-col2'>
            <div
              className={_actionBtnCloseClass}
              onClick={!bProjectClosed ? this._onInvoice.bind(this) : null}
            >
              <Button
                icon='action-estimate'
                className={_buttonInvoiceEstimateClass}
                canHover={false}
                tooltip={tooltipInvoiceEstimate}
                tooltipPosition='top'
              />
              <span className='label'>
                <IntlMessage ident='estimate.view.invoiceText' />
              </span>
            </div>
          </div>
          <div className='actionboard-col2 alert-col2'>
            <a
              className='action-btn'
              target='_blank'
              rel='noopener noreferrer'
              href={encodeURI(
                `/estimate/preview/${app.getTeamId()}/${app.loggedInId}/${
                  estimate ? estimate.id : ''
                }/${pdfFileName}`
              )}
            >
              <Button
                icon='action-download'
                className='button_dialog'
                canHover={false}
              />
              <span className='label'>
                <IntlMessage ident='estimate.view.downloadText' />
              </span>
            </a>
          </div>
        </div>
        <div className='actionboard-row act-row'>
          <div
            className='actionboard-col2 alert-col2'
            id='options-copy-estimate'
          >
            <div
              className='action-btn'
              onClick={this._onCopy.bind(this, estimate)}
            >
              <Button
                icon='action-copy'
                className='button_dialog'
                canHover={false}
              />
              <span className='label'>
                <IntlMessage ident='estimate.list.actionCopy' />
              </span>
            </div>
          </div>
          <div className='actionboard-col2 alert-col2'>
            <div
              className='action-btn'
              onClick={this._onSendMail.bind(this, estimate)}
            >
              <Button
                icon='header-mail'
                className='button_dialog'
                canHover={false}
              />
              <span className='label'>
                <IntlMessage ident='estimate.list.actionMail' />
              </span>
            </div>
          </div>
        </div>
        <ConfirmDelete
          ref={this._references.confirmDelete}
          title='estimate.view.confirmTitle'
          onClickOk={this._onClickDeleteConfirm.bind(this)}
        />
        <ConfirmDelete
          ref={this._references.confirmDecline}
          title='estimate.view.confirmTitle'
          onClickOk={this._onClickDeclineConfirm.bind(this)}
        />
      </DialogSetting>
    )
  }

  _getListCloumns () {
    const projectSetting = app.projectSetting

    return [
      {
        label: 'estimate.view.labelClient',
        identifier: 'company',
        width: '15%',
        sort: false,
        filterType: 'autocomplete',
        type: 'link',
        field: 'contact'
      },
      {
        label: projectSetting.useProjectNo
          ? 'estimate.view.labelProjectNumber'
          : 'estimate.view.labelProject',
        identifier: projectSetting.useProjectNo ? 'projectNumber' : 'title',
        width: '15%',
        sort: true,
        filterType: 'autocomplete',
        type: 'text',
        field: 'project'
      },
      {
        label: 'estimate.view.labelEstimate',
        identifier: 'estimateNumber',
        width: '15%',
        sort: true,
        filterType: 'number',
        type: 'text'
      },
      {
        label: 'estimate.view.labelAmount',
        identifier: 'totalExcl',
        width: '15%',
        sort: true,
        filterType: 'number',
        type: 'custom',
        customType: 'price'
      },
      {
        label: 'estimate.view.labelStatus',
        identifier: 'status',
        width: '12%',
        sort: true,
        filterType: 'date',
        type: 'text'
      },
      {
        label: 'estimate.view.labelCreated',
        identifier: 'createdOn',
        width: '13%',
        sort: true,
        filterType: 'date',
        type: 'date'
      },
      {
        label: 'estimate.view.labelInvoiced',
        identifier: 'invoicedAmount',
        width: '15%',
        sort: true,
        filterType: 'date',
        type: 'custom',
        customType: 'price'
      }
    ]
  }

  _getSortOptions () {
    return [
      // disabled until we fix the sort function
      // { label: 'estimate.view.labelClient', value: 'company' },
      { label: 'estimate.view.labelEstimate', value: 'estimateNumber' },
      { label: 'estimate.view.labelAmount', value: 'totalExcl' },
      { label: 'estimate.view.labelStatus', value: 'status' },
      { label: 'estimate.view.labelCreated', value: 'createdOn' },
      { label: 'estimate.view.labelInvoiced', value: 'invoicedAmount' }
    ]
  }

  _onPaginate () {
    if (this.data.canPaginate) {
      const page = this.data.pageNo + 1
      this.data.pageNo = page
      this._getData(true)
    }
  }

  _onSort (sort, sortAsc) {
    this.data.pageState.sort = sort
    this.data.pageState.sortAsc = sortAsc
    this.data.pageNo = 1
    this._getData(true)
  }

  _onRenderList (estimate, column, idx) {
    const value = estimate[column.identifier]
    const width = column.width

    if (column.customType === 'price') {
      return (
        <ReportPriceCell
          price={value}
          width={width}
          showtooltip={false}
          key={idx}
        />
      )
    }
    return ''
  }

  _onRenderGrid (estimate) {
    const projectSetting = app.projectSetting
    const pdfFileName = Util.getPdfFileName(
      'estimate',
      estimate.estimateNumber,
      estimate.status
    )

    return (
      <EstimateItem
        estimate={estimate}
        showProjectNumber={projectSetting.useProjectNo}
        key={estimate.id}
        onView={this._onGridItemClick.bind(this)}
        onSetting={this._onGridItemSettingClick.bind(this)}
        downloadUrl={`/estimate/preview/${app.getTeamId()}/${app.loggedInId}/${
          estimate.id
        }/${pdfFileName}`}
      />
    )
  }

  /* _onSearchProject(keyword, callback) {
    this._onCommonFilterProjectSearch(keyword, false, callback);
  } */

  _onSearchContact (keyword, callback) {
    this._onCommonFilterContactSearch(keyword, callback)
  }

  _initEvents () {
    this._eventHandlers.estimateCreated = this._eventReload.bind(
      this,
      'Estimate',
      'Created'
    )
    this._eventHandlers.estimateUpdated = this._eventReload.bind(
      this,
      'Estimate',
      'Updated'
    )
    this._eventHandlers.estimateRemoved = this._eventReload.bind(
      this,
      'Estimate',
      'Removed'
    )
    this._eventHandlers.estimatePatched = this._eventReload.bind(
      this,
      'Estimate',
      'Patched'
    )

    const estimateService = app.service('/api/estimate')
    estimateService.on('created', this._eventHandlers.estimateCreated)
    estimateService.on('updated', this._eventHandlers.estimateUpdated)
    estimateService.on('removed', this._eventHandlers.estimateRemoved)
    estimateService.on('patched', this._eventHandlers.estimatePatched)
  }

  _releaseEvents () {
    const estimateService = app.service('/api/estimate')
    estimateService.off('created', this._eventHandlers.estimateCreated)
    estimateService.off('updated', this._eventHandlers.estimateUpdated)
    estimateService.off('removed', this._eventHandlers.estimateRemoved)
    estimateService.off('patched', this._eventHandlers.estimatePatched)

    this._eventHandlers.estimateCreated = null
    this._eventHandlers.estimateUpdated = null
    this._eventHandlers.estimateRemoved = null
    this._eventHandlers.estimatePatched = null
  }

  _eventReload (objectName, eventName, eventData) {
    if (this._canRealTimeReload() && eventfilters.teamFilter(eventData)) {
      app.debug(`-- Event - PageEstimate - ${objectName} - ${eventName} --`)
      this.data.pageNo = 1
      this._getData(true)
    }
  }

  /* Header Functions - START */
  renderHeader () {
    const { stat, pageState } = this.data
    const currYear = DateUtil.getLocalYear()
    const currMonth = DateUtil.getLocalMonth()
    const lastWeekStartDate = DateUtil.getMondayByDate(new Date())
    lastWeekStartDate.setDate(lastWeekStartDate.getDate() - 7)
    const filter = pageState.filter || {}
    const projectSetting = app.projectSetting

    const statInfos = [
      {
        title: 'estimate.list.filterLabelOpen',
        value: stat ? stat.totalOpen : 0,
        isPrice: true
      },
      {
        title: `${IntlUtil.convertMessage(
          'estimate.list.filterLabelApproved'
        )} ${currYear}`,
        value: stat ? stat.totalApproved : 0,
        isPrice: true,
        isMultilingual: false
      },
      {
        title: `${IntlUtil.convertMessage(
          'estimate.list.filterLabelDeclined'
        )} ${currYear}`,
        value: stat ? stat.totalDeclined : 0,
        isPrice: true,
        isMultilingual: false
      }
    ]

    const filters = [
      {
        ident: 'status',
        type: 'option',
        label: 'estimate.list.filterLabelAll',
        options: [
          { label: 'estimate.list.filterLabelAll', ident: 'all' },
          { label: 'estimate.list.filterLabelOpen', ident: 'Open' },
          { label: 'estimate.list.filterLabelDraft', ident: 'Draft' },
          { label: 'estimate.list.filterLabelApproved', ident: 'Approved' },
          { label: 'estimate.list.filterLabelDeclined', ident: 'Declined' }
        ],
        isMulti: false,
        value: filter.status || '',
        defaultValue: 'all'
      },
      {
        type: 'label',
        label: 'estimate.list.filterLabelOffer'
      },
      {
        ident: 'project',
        type: 'tag',
        label: 'estimate.list.filterLabelProjects',
        placeholder: 'estimate.list.searchProjectPlaceholder',
        isMulti: false,
        value: filter.project || null
      },
      {
        type: 'label',
        label: 'estimate.list.filterLabelFor'
      },
      {
        ident: 'contact',
        type: 'tag',
        label: 'estimate.list.filterLabelClient',
        placeholder: 'estimate.list.searchClientPlaceholder',
        isMulti: false,
        value: filter.contact || null
      },
      {
        type: 'label',
        label: 'estimate.list.filterLabelAnd'
      },
      {
        ident: 'datefilter',
        type: 'date',
        label: 'estimate.list.filterLabelPeriods',
        isMulti: true,
        value: filter.datefilter || null,
        dateOptions: [
          {
            ident: 'last-week',
            label: 'estimate.list.filterDateWeek',
            value: {
              from: DateUtil.getUTCDateFromDate(lastWeekStartDate),
              to: DateUtil.getUTCDateFromTime(
                lastWeekStartDate.getTime() + 1000 * 7 * 24 * 60 * 60
              )
            }
          },
          {
            ident: 'last-month',
            label: 'estimate.list.filterDateMonth',
            value: {
              from: DateUtil.getUTCDate(currYear, currMonth - 1, 1),
              to: DateUtil.getUTCDate(currYear, currMonth, 0, 23, 59, 59)
            }
          },
          {
            ident: 'this-month',
            label: 'estimate.list.filterDateThisMonth',
            value: {
              from: DateUtil.getUTCDate(currYear, currMonth, 1),
              to: DateUtil.getUTCDate(currYear, currMonth + 1, 0, 23, 59, 59)
            }
          },
          {
            ident: 'this-year',
            label: 'estimate.list.filterDateYear',
            value: {
              from: DateUtil.getUTCDate(currYear, 0, 1),
              to: DateUtil.getUTCDate(currYear, 11, 31, 23, 59, 59)
            }
          },
          {
            ident: 'last-year',
            label: 'estimate.list.filterDateLastYear',
            subtitle: currYear - 1,
            value: {
              from: DateUtil.getUTCDate(currYear - 1, 0, 1),
              to: DateUtil.getUTCDate(currYear - 1, 11, 31, 23, 59, 59)
            }
          }
        ]
      }
    ]

    return (
      <PageHeader
        ref={this._references.refHeaderEstimate}
        title='estimate.list.titleEstimate'
        placeholderSearch={
          projectSetting.useProjectNo
            ? 'estimate.list.searchPlaceholderWithProjectNumber'
            : 'estimate.list.searchPlaceholder'
        }
        icon={<EstimatesIcon width={25} />}
        statInfos={statInfos}
        hasFilter
        hasSearch
        filters={filters}
        showGridList
        isGridActive={pageState.type === 'grid'}
        keywordSearch={filter.keyword}
        onGridListToggle={this._onHeaderGridListToggle.bind(this)}
        onChange={this._onHeaderChangeFilter.bind(this)}
        onSearchTags={this._onHeaderSearchTags.bind(this)}
      />
    )
  }

  _onHeaderGridListToggle (isGridActive) {
    this.data.pageState.type = isGridActive ? 'grid' : 'list'
    this._updatePageState(this.data.pageState)

    this.setState({ dataDate: new Date() })
  }

  _onHeaderChangeFilter (filter) {
    this.data.pageState.filter = filter
    this.data.pageNo = 1

    this._getData(true)
  }

  _onHeaderSearchTags (filterIdent, keyword, callback) {
    if (filterIdent === 'project') {
      this._onCommonFilterProjectSearch(keyword, false, callback)
    } else if (filterIdent === 'contact') {
      this._onCommonFilterContactSearch(keyword, callback)
    }
  }
  /* Header Functions - END */
}

export default PageEstimate
